<template>
  <div class="recall-page">
    <div v-wechat-title="'最强蜗牛'"></div>
    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' :gameName="gameName" :game_id="39"
      :downloadUrl="downloadUrl" :loginTypes="loginTypes" channelTips="角色UID可在游戏中—设置—UID查看" :autoOpenOS='false'
      @loginSuccess="loginSuccess" noAuthLogin></Login>
    <Os v-if='isShowOs' v-on:logoutCallback='osCancell'
    @getSelectInfo='getSelectInfo' :gameName="gameName"></Os>
    <!-- 头部 -->
    <Header v-if='true' :config='headerConfig' :downloadApp="downloadApp" :isShowInfo='true' :isOnline='1' @reInit="reInit" />

    <!-- 首页 -->
    <div :class="`active-page ${(isBook && signCount !== 3) ? 'sign-bg': '' }`">
        <div class="section-container">
          <div class="section section1">
            <div class="btn-box">
              <div class="btn taptap-btn" @click="goLink('https://l.taptap.cn/ovT12vw0?channel=rep-rep_uvbcbbs5do5', '五周年庆_点击taptap按钮')"></div>
              <div class="btn hykb-btn" @click="goLink('https://m.3839.com/a/117233.htm', '五周年庆_点击好游快爆按钮')"></div>
            </div>
            <div class="banner"></div>

            <div :class="['top-box',{show: showTopBox}]">
              <div v-if="!isBook" class="welfare-box">
                <div class="detail-btn" @click="showPopup('welfareDetailShow')"></div>
                <div class="appoint-btn" @click="appoint()"></div>
                <div class="wn-1"></div>
                <div class="wn-2"></div>
              </div>
              <div v-else-if="signCount === 3" class="award-box">
                <div class="detail-btn" @click="showPopup('welfareDetailShow')"></div>
                <div class="wn-1"></div>
                <div class="wn-2"></div>
                <div class="download-btn" @click="download"></div>
              </div>
              <div v-else class="sign-box">
                <div v-if="showTitleBox" class="title-box">
                  <div :class="titleClass"></div>
                  <div class="detail-btn" @click="showPopup('welfareDetailShow')"></div>
                </div>
                <div v-if="currentButtonType === 'tip'" class="s-btn tip-btn"></div>
                <div v-else class="s-btn sign-btn" @click="sign()"></div>
                <div class="wn-1"></div>
                <div class="wn-2"></div>
                <div :class="`award-got-box got-0${signCount}`"></div>
              </div>
            </div>
            <div class="carnival-box"></div>
            <div class="version-box">
              <div class="select-box">
                  <div
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :class="`hex-button hex-button-${index+1} ${activeIndex === index ? 'active' : ''}`"
                    @click="handleSlideChange(index)"
                  >
                  </div>
              </div>
              <div class="swiper-container-version">
                <div class="swiper-wrapper">
                    <div class="swiper-slide card-1">
                      <div class="top-content">
                        <img src="https://download4.qcplay.com/h5-images/active/snail/recall/1/version_01_01.png" alt="">
                      </div>
                      <div class="bottom-content">
                        <img src="https://download4.qcplay.com/h5-images/active/snail/recall/1/version_01_02.png" alt="">
                      </div>
                    </div>
                    <div class="swiper-slide card-2">
                      <div class="top-content">
                        <img src="https://download4.qcplay.com/h5-images/active/snail/recall/1/version_02_01.png" alt="">
                      </div>
                      <div class="bottom-content">
                        <img src="https://download4.qcplay.com/h5-images/active/snail/recall/1/version_02_02.png" alt="">
                      </div>
                    </div>
                    <div class="swiper-slide card-3">
                      <div class="top-content">
                        <img src="https://download4.qcplay.com/h5-images/active/snail/recall/1/version_03_01.png" alt="">
                      </div>
                      <div class="bottom-content">
                        <img src="https://download4.qcplay.com/h5-images/active/snail/recall/1/version_03_02.png" alt="">
                      </div>
                    </div>
                </div>
              </div>
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
              <div class="swiper-pagination"></div>
              <div class="hoop"></div>
            </div>
          </div>
        </div>
      </div>

    <!-- 周年服福利详情弹窗 -->
    <div class="welfare-detail-pop popup_wrap" v-show="welfareDetailShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="welfare-box popup_wrap-box" v-show="welfareDetailShow">
          <div class="detail-content-wrapper">
            <div class="detail-content"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="welfareDetailShow" @click="closePopup('welfareDetailShow')"></div>
    </div>

    <!-- 周年服预约成功弹窗 -->
    <div class="appoint-success-pop popup_wrap" v-show="appointSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="success-box popup_wrap-box" v-show="appointSuccessShow">
          <div class="confirm-btn" @click="changeToSign()"></div>
        </div>
      </transition>
    </div>

    <!-- 每日签到成功弹窗 -->
    <div class="sign-success-pop popup_wrap" v-show="signSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="success-box popup_wrap-box" v-show="signSuccessShow">
          <div class="confirm-btn" @click="closePopup('signSuccessShow')"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { Toast , Indicator} from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Header from '../Header/index.vue';
import Footer from '@/components/Footer'
import { headerConfig } from '../headerConfig';
import { onGetInitDataAPI , appointAPI , signAPI  } from '../api'
import { getRandomString , buriedLogger } from '@/utils/utils'
import { swiper , swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'recall',
  components: {
    Header,
    Footer,
    Login,
    Os,
    swiper,
    swiperSlide,
  },
  // props: ['downloadApp'],
  props: {
    downloadApp: {
      type: Function,
      default: () => {
        return () => { }
      }
    }
  },
  data () {
    return {
      headerConfig,
      logger: null,
      gameName: 'snail',
      account: null,
      user_id: null,
      role_name: '',
      server_name: '',
      downloadUrl: 'http://snail.qingcigame.com/official/',
      loginTypes: ["sms", "password"],
      mySwiper: null,
      tabs: [1, 2, 3],
      activeIndex: 0,
      showTopBox: false,
      showTitleBox: false,
      isBook: false,
      isCanSign: false,
      isDaySign: false,
      signCount: 0,

      isActiveAppointment: true, // 默认在预约期

      // 弹窗
      welfareDetailShow: false, // 福利详情弹窗
      appointSuccessShow: false, // 预约成功弹窗
      signSuccessShow: false, // 签到成功弹窗
    }
  },
  created () {
    // 埋点
    const bl = buriedLogger('snail', '五周年庆_预约页');
    this.logger = bl;
    setTimeout(() => {
      this.logger.sum('五周年庆_预约页');
    }, 200);

    const targetDate = new Date('2025/06/20 4:59:59');
    // 获取当前时间
    const currentDate = new Date();
    // 计算时间差
    const timeDifference = targetDate - currentDate;
    // 如果时间差大于0，说明在预约期，否则不在预约期
    this.isActiveAppointment = timeDifference ? true : false;
  },
  mounted () {
    this.$nextTick(() => {
      this.isSetShare();
      this.getLoginContainer();
    })
    this.versionSwiper();
  },
  computed: {
    titleClass() {
      const count = (!this.isDaySign && this.signCount !== 3)
        ? this.signCount + 1
        : this.signCount;

      return `title title-${count}`;
    },
    currentButtonType() {
      if (this.signCount === 0 && !this.isCanSign) return 'tip';
      if (!this.isDaySign) return 'sign';
      return 'tip';
    },
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin', 'isShowOs']),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {
            if (!newValue.account) {
              // TAG: 注销的时候
              this.reInit();
            } else {
              // console.log('登录成功');
              this.getLoginContainer()
            }
          }
        }
      }
    },
  },
  methods: {
    // 初始化
    getLoginContainer() {
      onGetInitDataAPI()
        .then((response) => {
          if (Number(response.code) == 200) {
            this.activity = response.data.activity;
            this.user_info = response.data.user_info;
            this.user_id = response.data.user_info.user_id;
            this.role_name = response.data.user_info.role_name;
            this.server_name = response.data.user_info.server_name;

            this.isBook = response.data.activity.is_book; // 是否预约

            this.isCanSign = response.data.activity.sign.is_can_sign; // 能否签到
            this.isDaySign = response.data.activity.sign.is_day_sign; // 今天是否签到过
            this.signCount = response.data.activity.sign.sign_count; // 累计签到次数

            this.onInitDataCallback(response);
            this.setUserInfo(response.data.user_info);
            this.setActiveInfo(response.data.activity);

            setTimeout(() => { this.showTopBox = true; }, 10);
            setTimeout(() => { this.showTitleBox = true; }, 200);
            return;
          }else {
            setTimeout(() => { this.showTopBox = true; }, 10);
          }
        })
    },
    getSelectInfo(selectInfo) {
      this.selectInfo = selectInfo;
      selectInfo.account = this.userInfo.account;
      this.setUserInfo(selectInfo);
    },
    // 区组弹窗注销-相关参数复位
    osCancell() {
      this.changeOsPopup(false);
    },
    versionSwiper() {
      this.mySwiper = new Swiper('.swiper-container-version', {
        slidesPerView: 1,
        loop: true,
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        onSlideChangeStart: (swiper) => {
          this.activeIndex = swiper.realIndex;
        }
      });

      this.activeIndex = this.mySwiper.realIndex;
    },
    handleSlideChange(index){
      const trackMap = [
        '版本-新主角',
        '版本-新地区',
        '版本-新载具'
      ];

      const eventName = trackMap[index];
      if (eventName) {
        this.logger.sum(`五周年庆_${eventName}`);
      }

      this.goToSlide(index);
    },
    goToSlide(targetIndex) {
      const swiper = this.mySwiper;
      const currentIndex = swiper.activeIndex;
      const slides = Array.from(swiper.slides);

      const matchingIndexes = slides
        .map((slide, i) => ({
          index: i,
          realIndex: +slide.getAttribute('data-swiper-slide-index')
        }))
        .filter(slide => slide.realIndex === targetIndex)

      const nearest = matchingIndexes.reduce((prev, curr) => {
        return Math.abs(curr.index - currentIndex) < Math.abs(prev.index - currentIndex)
          ? curr
          : prev;
      });

      if (nearest) {
        swiper.slideTo(nearest.index, 200);
        this.activeIndex = targetIndex;
      }
    },
    // 预约逻辑
    appoint(){
      this.logger.sum('五周年庆_立即预约');

      // 有无登录
      if (this.userInfo.account === undefined || this.userInfo.account === '') {
        // this.autoOpenOS = true;
        this.changeLoginPopup(true);
        return
      }

      appointAPI().then((response) => {
          if (response.code == 200) {
            this.appointSuccessShow = true;
            this.logger.sum('五周年庆_预约成功');
            this.isBook = true;
            this.getLoginContainer();
          } else {
            this.onToast(response.message);
          }
        });
    },
    sign(){
      this.logger.sum('五周年庆_day' + (this.signCount + 1) + '签到-立即领取');
      signAPI().then((response) => {
          if (response.code == 200) {
            this.signSuccessShow = true;
            this.getLoginContainer()
          } else {
            this.onToast(response.message);
          }
        });
    },
    download(){
      this.logger.sum('五周年庆_day3签到-下载游戏');
      this.downloadApp();
    },
    // 预约后转为签到
    changeToSign(){
      this.appointSuccessShow = false;
    },
    loginSuccess() {
      this.getLoginContainer();
    },
    reInit() {
     this.changeOsPopup(false);
     this.clearActiveInfo();
    },
    clearActiveInfo(){
      this.isBook = false;
      this.isCanSign = false;
      this.isDaySign = false;
      this.signCount = 0;

      this.setInitUserInfo();
      this.setInitActiveInfo();
    },
    onToast (config , duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig)
    },
    showPopup (name) {
      switch (name) {
        case 'welfareDetailShow':
          this.welfareDetailShow = true;
          this.logger.sum('五周年庆_打开福利详情弹窗');
          break
      }
    },
    goLink(url, loggerName) {
        if (url === '') return
        Indicator.open();
        this.logger.sum(loggerName)
        setTimeout(() => { window.location.href = url; Indicator.close(); }, 200)
    },
    closePopup(name) {
      this[name] = false;
    },
    // 微信分享
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/recall/anniversary${getRandomString()}`,
        title: '《最强蜗牛》五周年版本上线',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/sTsPyCJ08V30Y19cL9SoXTH5RFXqt6eaC3v60hP6.png',
        desc: '什么！百抽都成基础福利了？'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");

</style>



// WEBPACK FOOTER //
// src/pages/snail/recall/anniversary/index.vue